/* Aereé collection page: hero reveal + disc parallax, editorial grid reveals, hover loupe, quick add, load more. */
(() => {
  if (window.__aeColl) { window.__aeColl(); return; }
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  const store = { get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }, set(k, v) { try { localStorage.setItem(k, v); } catch (e) {} } };

  /* ---------- hero ---------- */
  function initHero(root) {
    if (!root || root.__ae) return;
    root.__ae = true;
    const t = root.querySelector('[data-ach-title]');
    if (t && !t.dataset.split) {
      t.dataset.split = '1';
      const text = t.textContent.trim();
      const words = text.split(/\s+/);
      t.setAttribute('aria-label', text);
      t.innerHTML = '';
      words.forEach((w, i) => {
        const outer = document.createElement('span');
        outer.className = 'w'; outer.setAttribute('aria-hidden', 'true');
        const inner = document.createElement(i === words.length - 1 && words.length > 1 && t.dataset.accent === 'true' ? 'em' : 'span');
        inner.textContent = w;
        const wrap = document.createElement('span');
        wrap.style.setProperty('--i', i);
        wrap.appendChild(inner);
        outer.appendChild(wrap);
        t.appendChild(outer);
        if (i < words.length - 1) t.appendChild(document.createTextNode(' '));
      });
      // single-word titles get the italic accent on the whole word
      if (words.length === 1 && t.dataset.accent === 'true') {
        const span = t.querySelector('.w > span');
        span.innerHTML = '<em>' + span.textContent + '</em>';
      }
    }
    requestAnimationFrame(() => requestAnimationFrame(() => root.classList.add('is-in')));

    const disc = root.querySelector('[data-ach-disc]');
    if (disc && !reduce) {
      let ticking = false;
      const upd = () => {
        ticking = false;
        const r = root.getBoundingClientRect();
        const y = Math.max(-1, Math.min(1, -r.top / Math.max(1, r.height)));
        disc.style.transform = 'translate3d(0,' + (y * 60).toFixed(1) + 'px,0) rotate(' + (y * 25).toFixed(2) + 'deg)';
      };
      window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(upd); } }, { passive: true });
      upd();
    }
  }

  /* ---------- grid ---------- */
  let io = null;
  function reveal(cell) {
    if (reduce || !('IntersectionObserver' in window)) { cell.classList.add('is-in'); return; }
    if (!io) {
      io = new IntersectionObserver((entries) => {
        // stagger cards that arrive together, in reading order
        const batch = entries.filter((e) => e.isIntersecting).map((e) => e.target)
          .sort((a, b) => { const ra = a.getBoundingClientRect(), rb = b.getBoundingClientRect(); return (ra.top - rb.top) || (ra.left - rb.left); });
        batch.forEach((el, i) => { el.style.setProperty('--aa-d', (i * 110) + 'ms'); el.classList.add('is-in'); io.unobserve(el); });
      }, { rootMargin: '0px 0px -6% 0px', threshold: 0.08 });
    }
    io.observe(cell);
  }

  function initCell(cell, root) {
    if (cell.__ae) return;
    cell.__ae = true;
    reveal(cell);
    const media = cell.querySelector('[data-aa-media]');
    const cursor = root.querySelector('[data-aa-cursor]');
    if (media && fine) {
      media.addEventListener('pointerenter', () => { cell.classList.add('is-hover'); if (cursor) cursor.classList.add('is-on'); });
      media.addEventListener('pointerleave', () => { cell.classList.remove('is-hover'); if (cursor) cursor.classList.remove('is-on'); });
      media.addEventListener('pointermove', (e) => {
        const r = media.getBoundingClientRect();
        media.style.setProperty('--mx', (e.clientX - r.left) + 'px');
        media.style.setProperty('--my', (e.clientY - r.top) + 'px');
        if (cursor) cursor.style.left = e.clientX + 'px', cursor.style.top = e.clientY + 'px';
      });
    }
    const form = cell.querySelector('[data-aa-add]');
    if (form) form.addEventListener('submit', (e) => { e.preventDefault(); quickAdd(form, root); });
  }

  async function quickAdd(form, root) {
    const btn = form.querySelector('button');
    btn.classList.add('is-busy');
    try {
      const res = await fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(form.querySelector('[name=id]').value), quantity: 1 }] })
      });
      if (!res.ok) throw new Error('add failed');
      const cart = await (await fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js')).json();
      toast(root, 'Added to your bag');
      // let the theme's cart icon refresh its count
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'aeree-collection', data: { itemCount: cart.item_count, source: 'aeree-collection' } } }));
      document.querySelectorAll('.cart-count, [data-cart-count], .cart-bubble__text-count').forEach((el) => { el.textContent = cart.item_count; });
    } catch (err) {
      form.submit();
    } finally {
      btn.classList.remove('is-busy');
    }
  }

  function toast(root, msg) {
    const t = root.querySelector('[data-aa-toast]');
    if (!t) return;
    t.querySelector('[data-aa-toast-text]').textContent = msg;
    t.classList.add('is-on');
    clearTimeout(t.__h);
    t.__h = setTimeout(() => t.classList.remove('is-on'), 3600);
  }

  function initGrid(root) {
    if (!root || root.__ae) return;
    root.__ae = true;
    const grid = root.querySelector('[data-aa-grid]');
    if (grid) grid.querySelectorAll('[data-aa-cell]').forEach((c) => initCell(c, root));

    // density toggle (remembered per visitor)
    const btns = root.querySelectorAll('[data-aa-cols]');
    const apply = (n) => {
      root.style.setProperty('--aa-cols', n);
      btns.forEach((b) => b.classList.toggle('is-on', b.dataset.aaCols == n));
    };
    if (window.innerWidth >= 750) {
      apply(store.get('aeree-cols') || root.dataset.cols);
      btns.forEach((b) => b.addEventListener('click', () => { apply(b.dataset.aaCols); store.set('aeree-cols', b.dataset.aaCols); }));
    } else {
      // on phones the toggle switches between 1 and 2 per row
      btns.forEach((b) => { if (b.dataset.aaCols === '4') b.hidden = true; });
      const s2 = root.querySelector('[data-aa-cols="2"]'); const s3 = root.querySelector('[data-aa-cols="3"]');
      if (s2) { s2.textContent = 'I'; s2.setAttribute('aria-label', '1 per row'); }
      if (s3) { s3.textContent = 'II'; s3.setAttribute('aria-label', '2 per row'); }
      const m = store.get('aeree-mcols') || '2';
      root.style.setProperty('--aa-mcols', m);
      if (s2) s2.classList.toggle('is-on', m === '1');
      if (s3) s3.classList.toggle('is-on', m === '2');
      [s2, s3].forEach((b) => b && b.addEventListener('click', () => {
        const v = b === s2 ? '1' : '2';
        root.style.setProperty('--aa-mcols', v); store.set('aeree-mcols', v);
        s2.classList.toggle('is-on', v === '1'); s3.classList.toggle('is-on', v === '2');
      }));
    }

    // load more
    const more = root.querySelector('[data-aa-more]');
    const shown = root.querySelector('[data-aa-shown]');
    if (more && grid) {
      let busy = false;
      const load = async () => {
        if (busy || !more.dataset.next) return;
        busy = true; more.classList.add('is-busy');
        try {
          const url = more.dataset.next + (more.dataset.next.includes('?') ? '&' : '?') + 'section_id=' + encodeURIComponent(root.dataset.section);
          const doc = new DOMParser().parseFromString(await (await fetch(url)).text(), 'text/html');
          doc.querySelectorAll('[data-aa-grid] > [data-aa-cell]').forEach((c) => { const n = document.importNode(c, true); grid.appendChild(n); initCell(n, root); });
          if (shown) shown.textContent = grid.querySelectorAll('.aa-cell:not(.aa-note-cell)').length;
          const nb = doc.querySelector('[data-aa-more]');
          if (nb && nb.dataset.next) more.dataset.next = nb.dataset.next; else { more.dataset.next = ''; more.closest('.aag-more').classList.add('is-done'); }
          const sm = root.querySelector('.aag-more small'); if (sm && shown) sm.textContent = shown.textContent + ' of ' + (root.querySelector('.aag-bar span').textContent.match(/of (\d+)/) || [0, ''])[1];
        } catch (e) { window.location.href = more.dataset.next; }
        busy = false; more.classList.remove('is-busy');
      };
      more.addEventListener('click', load);
    }
  }

  function boot(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-ach]').forEach(initHero);
    scope.querySelectorAll('[data-aa-root]').forEach(initGrid);
  }
  window.__aeColl = () => boot(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(document)); else boot(document);
  document.addEventListener('shopify:section:load', (e) => boot(e.target));
})();
